import React from 'react'

import { Select } from '../../common/components/select'
import { selectComponentService } from '../../common/services/select-component.service'

export const DatasetSelect = function ({ label, selectedValue, options, isValid, onChange }) {
  return (
    <div className="select-field" data-qa="dataset-select">
      <Select
        label={label}
        options={options}
        value={selectComponentService.getSelectedValue(options, selectedValue)}
        message={isValid ? undefined : { type: 'warning', message: 'Dataset not found.' }}
        size="medium"
        onChange={onChange} />
    </div>
  )
}
